import React from "react"
import TextField from "@material-ui/core/TextField"
import Button from "@material-ui/core/Button"
import Box from "@material-ui/core/Box"

const EmailComponent = () => {
  const [email, setEmail] = React.useState("")
  return (
    <div style={{ display: "flex" }}>
      <TextField
        variant="outlined"
        style={{ width: "60%", borderRadius: "30px" }}
        label="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <Box ml={1} mt={1}>
        <Button
          style={{
            backgroundColor: "#EC7623",
            color: "white",
            borderRadius: "30px",
            paddingLeft: "4px",
            paddingRight: "4px",
          }}
        >
          Subscribe
        </Button>
      </Box>
    </div>
  )
}

export default EmailComponent
